import axios from 'axios'

import { setEndpointStatusOutside } from '../../../store/endpointStatus'

export const IS_PROD = process.env.NODE_ENV === 'production'

let prodBackend = 'https://app.marketcalculus.ai:9090'
let acao = 'https://app.marketcalculus.ai'
if (window.location.host.startsWith('test.marketcalculus.ai')) {
  prodBackend = 'https://test.marketcalculus.ai:9091'
  acao = 'https://test.marketcalculus.ai:9091'
}
export const BASE_URL = IS_PROD ? prodBackend : 'http://127.0.0.1:9090'
export const HOMEPAGE_URL = 'https://marketcalculus.ai'

const createAxiosInstance = () => {
  const instance = axios.create({
    baseURL: BASE_URL + '/b2b/api/v1',
    withCredentials: true
  })

  instance.interceptors.request.use(config => {
    const lang = localStorage.getItem('lang') || 'en'

    // Don't override Content-Type if it's FormData (for file uploads)
    const headers = {
      ...config.headers,
      'Access-Control-Allow-Origin': acao,
      dil: lang
    }

    // Only set Content-Type to application/json if data is not FormData
    if (!(config.data instanceof FormData)) {
      headers['Content-type'] = 'application/json'
    }

    config.headers = headers
    return config
  })

  instance.interceptors.response.use(
    (response) => {
      return response
    },
    async (err) => {
      let errorData = err?.response?.data
      if (errorData instanceof Blob) {
        try {
          const text = await errorData.text()
          errorData = JSON.parse(text)
        } catch {
          errorData = null
        }
      }

      // Handle two different exception structures:
      // detail.body.detail contains LimitExceptionDetail with ruleType
      // detail contains ruleType or code directly
      const nestedRuleType = errorData?.detail?.body?.detail?.ruleType
      const directRuleType = errorData?.detail?.ruleType || errorData?.detail?.code || errorData?.type

      if (nestedRuleType) {
        setEndpointStatusOutside('errorMessage', {
          ...errorData.detail.body.detail,
          ruleType: nestedRuleType
        })
        return Promise.reject(err)
      } else if (directRuleType) {
        setEndpointStatusOutside('errorMessage', {
          ...errorData.detail,
          ruleType: directRuleType
        })
        return Promise.reject(err)
      }

      const currentPath = window.location.pathname
      const isOnAuthPage = currentPath.includes('/login') ||
                          currentPath.includes('/register') ||
                          currentPath.includes('/error') ||
                          currentPath.includes('/reset') ||
                          currentPath.includes('/new-password')

      const skipGenericError = err?.config?.skipGenericErrorHandler

      if (err?.response?.status && err.response.status >= 400 && !isOnAuthPage && !skipGenericError) {
        setEndpointStatusOutside('errorMessage', {
          ruleType: 'GENERIC_HTTP_ERROR',
          statusCode: err.response.status,
          message: errorData?.message || errorData?.detail || 'An unexpected error occurred'
        })
        return Promise.reject(err)
      }

      if (!err?.response && !isOnAuthPage) {
        setEndpointStatusOutside('errorMessage', {
          ruleType: 'GENERIC_NETWORK_ERROR',
          message: 'Network error - please check your connection'
        })
      }

      return Promise.reject(err)
    }
  )

  return instance
}

const B2BAPI = createAxiosInstance()
export default B2BAPI
